import { Oval, TailSpin } from "react-loader-spinner";
import "./Loaders.scss";

export const LazyLoader = () => {
  return (
    <div className="loader-main">
      <Oval
        height={60}
        width={60}
        color="#3B82F6"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        ariaLabel="oval-loading"
        secondaryColor="#93C5FD"
        strokeWidth={2}
        strokeWidthSecondary={2}
      />
    </div>
  );
};

export const ButtonLoader = ({ color }) => {
  return (
    <TailSpin
      height="1.5rem"
      color={color ? color : "white"}
      radius="2"
      wrapperClass="loader-button"
      visible={true}
    />
  );
};
